/**
 * Labstep
 *
 * @module models/protocol-table
 * @desc Typescript export class for ProtocolTable
 */

import { Type } from 'class-transformer';
import { Entity } from 'labstep-web/models/entity.model';
import { ProtocolStep } from 'labstep-web/models/protocol-step.model';

export class ProtocolTable extends Entity {
  public static readonly idAttr = 'guid' as const;

  static readonly entityName = 'protocol_table' as const;

  get entityName(): string {
    return ProtocolTable.entityName;
  }

  constructor(data: Partial<ProtocolTable> = {}) {
    super();
    Object.assign(this, data);
  }

  name!: string;

  data!: Record<string, unknown>;

  @Type(() => ProtocolStep)
  protocol_step!: ProtocolStep;
}
